import React from 'react';

export const TestimonialsSection: React.FC = () => {
  const depoimentos = [
    {
      name: 'Maria Silva',
      company: 'Ateliê Criativo',
      text: 'A GMX Fortaleza transformou minha produção! A qualidade das estampas é excepcional e a entrega em 24h me permite atender meus clientes com muito mais agilidade.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/66f4b6ac8bf50404e011d3bc80a5ca71.jpg'
    },
    {
      name: 'João Santos',
      company: 'Confecções Premium',
      text: 'Trabalho com a GMX há 2 anos e nunca me decepcionaram. As cores são vibrantes, o tecido mantém a qualidade após várias lavagens. Recomendo para qualquer confecção.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Real%20everyday%20man%20smiling%20naturally%2C%20authentic%20portrait%20of%20regular%20person%2C%20casual%20business%20attire%2C%20natural%20lighting%2C%20genuine%20expression%2C%20realistic%20photography%2C%20everyday%20life%20portrait&width=100&height=100&seq=testimonial2real&orientation=squarish'
    },
    {
      name: 'Ana Costa',
      company: 'Marca Própria Fashion',
      text: 'O atendimento personalizado da GMX fez toda a diferença no lançamento da minha marca. Eles entenderam exatamente o que eu precisava e entregaram além das expectativas.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Real%20everyday%20woman%20entrepreneur%20smiling%2C%20authentic%20portrait%20of%20regular%20person%2C%20casual%20professional%20clothing%2C%20natural%20lighting%2C%20genuine%20happy%20expression%2C%20realistic%20photography%2C%20everyday%20life%20portrait&width=100&height=100&seq=testimonial3real&orientation=squarish'
    },
    {
      name: 'Carlos Oliveira',
      company: 'Têxtil Nordeste',
      text: 'A capacidade de produção da GMX é impressionante. Conseguimos atender grandes pedidos sem perder a qualidade. A parceria tem sido fundamental para nosso crescimento.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Real%20everyday%20businessman%20smiling%20naturally%2C%20authentic%20portrait%20of%20regular%20person%2C%20casual%20business%20clothing%2C%20natural%20lighting%2C%20genuine%20smile%2C%20realistic%20photography%2C%20everyday%20life%20portrait&width=100&height=100&seq=testimonial4real&orientation=squarish'
    }
  ];

  const certificacoes = [
    { name: 'ISO 9001', description: 'Qualidade Certificada' },
    { name: 'Eco-Friendly', description: 'Processos Sustentáveis' },
    { name: '100k+', description: 'Pedidos Entregues' },
    { name: '24h', description: 'Entrega Expressa' }
  ];

  return (
    <section id="depoimentos" className="py-16 md:py-20 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 lg:mb-20">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-2">O que nossos clientes dizem</h3>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 leading-relaxed">
              Mais de <strong>100.000 pedidos entregues</strong> com excelência. 
              Veja os depoimentos de quem confia na qualidade GMX.
            </p>
          </div>
          
          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16 lg:mb-20">
            {depoimentos.map((depoimento, index) => (
              <div key={index} className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-start mb-5 md:mb-6">
                  <img 
                    src={depoimento.image}
                    alt={`${depoimento.name} - Cliente GMX Fortaleza`}
                    className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full object-cover object-top mr-4 flex-shrink-0 ring-4 ring-purple-100"
                  />
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-gray-900 text-base sm:text-lg md:text-xl mb-1">{depoimento.name}</h4>
                    <p className="text-gray-600 text-xs sm:text-sm md:text-base mb-2">{depoimento.company}</p>
                    <div className="flex">
                      {[...Array(depoimento.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm sm:text-base md:text-lg text-gray-700 italic leading-relaxed">"{depoimento.text}"</p>
              </div>
            ))}
          </div>
          
          {/* Certificações e Selos */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg mb-12 md:mb-16">
            <h4 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8 md:mb-12">Certificações e Garantias</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {certificacoes.map((cert, index) => (
                <div key={index} className="text-center">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-5 shadow-lg hover:scale-105 transition-transform">
                    <span className="text-white font-bold text-sm sm:text-base md:text-lg px-2">{cert.name}</span>
                  </div>
                  <p className="text-xs sm:text-sm md:text-base text-gray-700 font-semibold">{cert.description}</p>
                </div>
              ))}
            </div>
          </div>
          
          {/* Cases de Sucesso */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
              <h4 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-6 md:mb-8">Cases de Sucesso</h4>
              <div className="space-y-4 md:space-y-5">
                <div className="flex items-start bg-green-50 rounded-xl p-4">
                  <i className="ri-check-double-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base md:text-lg text-gray-700 font-medium">Marca de moda praia - 50.000 peças em 1 semana</span>
                </div>
                <div className="flex items-start bg-green-50 rounded-xl p-4">
                  <i className="ri-check-double-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base md:text-lg text-gray-700 font-medium">Confecção de uniformes - Entrega em 12 horas</span>
                </div>
                <div className="flex items-start bg-green-50 rounded-xl p-4">
                  <i className="ri-check-double-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base md:text-lg text-gray-700 font-medium">Ateliê de alta costura - Estampas exclusivas</span>
                </div>
              </div>
            </div>
            
            <div className="relative h-64 sm:h-80 md:h-auto min-h-[400px] rounded-2xl md:rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=Showcase%20of%20beautiful%20printed%20textile%20products%2C%20colorful%20fabric%20samples%20with%20various%20patterns%2C%20high-quality%20textile%20printing%20results%2C%20professional%20product%20photography%2C%20vibrant%20colors&width=500&height=300&seq=showcase1&orientation=landscape"
                alt="Showcase de produtos GMX Fortaleza"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end">
                <p className="text-white p-6 sm:p-8 md:p-10 font-semibold text-base sm:text-lg md:text-xl leading-relaxed">
                  Resultados que falam por si só - Qualidade GMX em cada projeto
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
